import useAuthStore from 'context/AuthStore/useAuthStore'
import { Redirect, Route, Switch } from 'react-router-dom'
import {
  CHAT_PATH,
  HOME_PATH,
  REQUEST_PATH,
  SIGN_IN_PATH
} from 'routes/constants.routes'
import PrivateRoute from 'routes/PrivateRoute'
import { useHistory } from 'react-router'
import './App.css'
import axios from 'axios'
import Home from 'pages/Home/Home'
import RequestPage from 'pages/RequestPage/RequestPage'
import NoMatch from 'pages/NoMatch/NoMatch'
import SignIn from 'pages/SignIn/SignIn'
import ChatPage from 'pages/RequestPage/components/ChatCard/ChatPage'

function App() {
  const { authStore, authStoreFunc } = useAuthStore()
  const history = useHistory()

  axios.interceptors.response.use(
    response => response,
    error => {
      if (
        error.message.includes('401') ||
        [401, 403].includes(error?.request?.status)
      ) {
        localStorage.removeItem('clear')
        authStoreFunc.setLoading(false)
        history.push('/signin')
      } else {
        console.error(error)
      }
      return Promise.reject(error)
    }
  )

  return (
    <Switch>
      <PrivateRoute exact path={HOME_PATH} component={Home} />
      <PrivateRoute
        exact
        path={[REQUEST_PATH + '/:id']}
        component={RequestPage}
      />
      <PrivateRoute exact path={[CHAT_PATH + '/:id']} component={ChatPage} />
      <Route path={SIGN_IN_PATH} render={props => <SignIn {...props} />} />
      <Route
        path={'/'}
        render={() => (
          <Redirect to={authStore.isLoggedIn ? HOME_PATH : SIGN_IN_PATH} />
        )}
      />
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  )
}

export default App
